const route = () => `/search`;

export default route;
